import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Input, Type, ViewChild } from '@angular/core';
import { BaseCellComponent, ICellConfig, setupCell } from '../base-cell/base-cell.component';
import { IDclConfig } from '../../utilities/ngb-table.interface';

export interface IComposedCellConfig extends ICellConfig {
  configs: IDclConfig<any>[];
  orientation?: 'horizontal' | 'vertical';
}

@Component({
  selector: 'table-cell-composed',
  standalone: false,
  styleUrls: ['../base-cell/base-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      #composedRef
      class="d-flex position-relative"
      [ngClass]="{
        'align-items-center': !config.orientation || config.orientation === 'horizontal',
        'flex-column gap-1': config.orientation === 'vertical',
      }"
    >
      @for (type of types; track type; let i = $index) {
        <dcl-wrapper [type]="type" [config]="configs[i]"></dcl-wrapper>
      }
    </div>
  `,
})
export class ComposedCellComponent extends BaseCellComponent implements AfterViewInit {
  @Input() public config: IComposedCellConfig;
  @ViewChild('composedRef')
  public element: ElementRef<HTMLElement>;

  get types(): Type<any>[] {
    return this.config.configs.map((config: IDclConfig<any>) => config.type);
  }

  get configs(): ICellConfig[] {
    return this.config.configs.map((config: IDclConfig<any>) => config.config);
  }

  public ngAfterViewInit(): void {
    setupCell(this.renderer, this.config, this.element.nativeElement);
  }
}
